import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteInvoiceRequestForm.ShippingDetailsSection', {
    shippingDetailsSectionTitle: 'Shipping Details',
    dateFieldPlaceholder: 'Select date',
    shippingDateFieldText: 'Shipping date',
    shippingMethodFieldText: 'Shipping method',
    shippingMethodFieldPlaceholder: 'Select method',
    shippingAddressFieldText: 'Shipping address',
    shippingAddressFieldPlaceholder: 'Select address',
});
